import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent {
  @Input() control: AbstractControl = new FormControl();
  @Input() idForm: string;
  @Input() type: string = 'text';
  @Input() label: string = "";
  @Input() readOnly: boolean = false;
  @Input() placeholder: string = "";
  @Input() size: string = "";
  @Input() autocomplete: boolean = true;
  @Input() maxLength: any = null;
  @Input() tabIndex: number;
  @Input() iconPrepend: string;
  @Input() iconAppend: string;
  @Input() horizontal: boolean = false;
}
